import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  standalone: false,
  selector: 'app-categories-add',
  templateUrl: './categories-add.component.html',
})
export class CategoriesAddComponent {
  form: any = {
    name: '',
    status: 1,
  };
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private categoryService: CategoryService,
  ) {}

  submit(): void {
    this.validationTriggered = true;
    if (!this.form.name) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    this.categoryService.create({
      name: this.form.name,
      status: Number(this.form.status),
    }).subscribe({
      next: (result) => {
        this.toaster.success('Category added.');
        this.router.navigate(['/ecomm/categories', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add category.');
      },
    });
  }
}
